/**
 * Listing Header DOM Component
 *
 * Creates the sticky header element for the listing sheet, containing the title.
 *
 * @module nativeInteractiveSiteMap/components/listingHeader.dom
 */

import createListingTitle from './listingTitle.dom';

export default function createListingHeader() {
  const headerElement = document.createElement('div');
  headerElement.className = 'nhs-c-native-interactive-site-map__listing-header';
  headerElement.setAttribute('data-listing-header', '');

  const titleComponent = createListingTitle();
  headerElement.appendChild(titleComponent.getElement());

  return {
    getElement() {
      return headerElement;
    },
    setText(text) {
      titleComponent.setText(text);
    },
    remove() {
      headerElement.remove();
    },
  };
}
